module.exports = __webpack_public_path__ + "img/8_newYouth_ljf.d6fee497.png";